import { Skeleton } from "@/components/ui/skeleton";

export function LoadingState() {
  return (
    <div className="w-full border-b border-border bg-background/95 backdrop-blur-sm">
      <div className="flex items-center justify-between px-3 py-2">
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-4 rounded-full" />
          <Skeleton className="h-4 w-32 rounded" />
        </div>
        <Skeleton className="h-8 w-20 rounded" />
      </div>
      <div className="px-6 py-4">
        <div className="flex items-center gap-4">
          <Skeleton className="h-8 w-8 rounded-full" />
          <div className="flex gap-4">
            <Skeleton className="h-12 w-24 rounded" />
            <Skeleton className="h-12 w-24 rounded" />
            <Skeleton className="h-12 w-24 rounded" />
          </div>
        </div>
      </div>
    </div>
  );
}
